import {ItemGroup} from "./itemGroup";
import {GroupRepository} from './groupRepository';
import {XmlTagInfo} from '../xmlTagProvider'
import {Form} from '../form/form'
import {ComboItem} from "../items/combo";

export class ComboGroup extends ItemGroup<ComboItem> {

    displayWidth: number;
    optionsId: string;

    constructor(config: XmlTagInfo, form: Form){
        super(config, form);

        this.displayWidth = parseInt(config.attributes['displayWidth'], 10);
        this.optionsId = config.attributes['options']
    }
}

// @ts-ignore
GroupRepository.register('comboGroup', ComboGroup);
